import React from "react";
import { Spinner } from "react-bootstrap";

interface IProps {
    as?: "div" | "span";
    animation: "border" | "grow";
    size?: "sm";
    className?: string;
    variant?: "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark";
    onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

class BaseSpinner extends React.Component<IProps> {
    private handleOnClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        const { onClick } = this.props;
        onClick && onClick(event);
    };
    public render(): JSX.Element {
        const { as, animation, size, className } = this.props;

        return (
            <>
                <Spinner
                    as={as}
                    className={["align-self-center ocq-icon", className].join(" ")}
                    animation={animation}
                    size={size}
                    role="status"
                    onClick={this.handleOnClick}
                />
            </>
        );
    }
}

export { BaseSpinner as Unconnected };
export default BaseSpinner;
